// components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { CreateDeclarationTypeDrawer } from './components/CreateDeclarationTypeDrawer/CreateDeclarationTypeDrawer';

// hooks
import { useColumnDefinitions } from './DeclarationTypes.utils';
import { useDeclarationTypes } from './DeclarationTypes.hooks';
import { useTranslation } from 'react-i18next';

const DeclarationTypes = () => {
  const { t } = useTranslation('common');
  const { declarationTypes, isLoading, isError, refetch, onDeleteClick } =
    useDeclarationTypes();
  const columns = useColumnDefinitions();

  return (
    <TableCRUDLayout
      loading={isLoading}
      columns={columns}
      FormComponent={CreateDeclarationTypeDrawer}
      onClose={refetch}
      rows={declarationTypes}
      getRowId={(resource) => resource.id!}
      hasLoadingError={isError}
      onLoadingError={refetch}
      onDeleteClick={onDeleteClick}
      canBeDeletedProp="isDeletable"
      confirmationTitle={t('adminPortal.declarationTypes.confirmationTitle')}
      confirmationBody={t('adminPortal.declarationTypes.confirmationBody')}
    />
  );
};

export default DeclarationTypes;
